// export const BACKEND_URL = process.env.API_URL;
export const BACKEND_URL = "https://stag.3dlifestyle.ca/api/";

export const BACKEND_BASE_URL = "https://stag.3dlifestyle.ca/";
export const PRIVACY_POLICY = "https://3dlifestyle.ca/privacy-policy/";
export const LICENSE_AGREMENT = "https://3dlifestyle.ca/end-users-license-agreement/";
export const GOOGLE_API = "AIzaSyATqiD9Stu2kfdE1OZaO66J9_oV9rPtAR8";
// export const BACKEND_URL = "http://127.0.0.1:8000/api/";